import { render, staticRenderFns } from "./product-inventory-print.vue?vue&type=template&id=9516742a&scoped=true&"
import script from "./product-inventory-print.vue?vue&type=script&lang=ts&"
export * from "./product-inventory-print.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9516742a",
  null
  
)

export default component.exports